/**
 * Paths relative to axios baseURL (`{API_URL}/api`).
 * Kept in one place so the UI stays aligned with the Nest global prefix and routes.
 */
export const paths = {
  users: {
    me: "/users/me",
  },
  auth: {
    google: "/auth/google",
    logout: "/auth/logout",
    me: "/auth/me",
  },
  players: {
    list: "/players",
    one: (id: string) => `/players/${id}`,
    bonus: (id: string) => `/players/${id}/bonus`,
  },
  matches: {
    list: "/matches",
    one: (id: string) => `/matches/${id}`,
    end: (id: string) => `/matches/${id}/end`,
    events: (matchId: string) => `/matches/${matchId}/events`,
    event: (matchId: string, eventId: string) =>
      `/matches/${matchId}/events/${eventId}`,
    score: (matchId: string) => `/matches/${matchId}/score`,
  },
  teams: {
    generate: "/teams/generate",
  },
  statistics: {
    players: "/statistics/players",
    summary: "/statistics/summary",
  },
  shareCodes: {
    list: "/share-codes",
    redemptions: "/share-codes/redemptions",
    one: (id: string) => `/share-codes/${id}`,
  },
  export: {
    playersCsv: "/export/players/csv",
  },
} as const;
